/* eslint-disable react-hooks/exhaustive-deps */
'use client';

import { calculateCollapsedButtonOrder } from '@fe-common-utils/libs/collapse';
import Event from '@fe-common-utils/libs/event';
import debounce from 'lodash.debounce';
import { useEffect, useState } from 'react';

const DEFAULT_VALUE = -1;
const ROW_LIMIT = 3;
const READ_MORE_BUTTON_WIDTH = 66;
const GAP = 12;
const MAX_ORDER = 99;

const useFolder = (
  target: React.RefObject<HTMLDivElement> | null,
  limit: number = ROW_LIMIT,
  buttonWidth: number = READ_MORE_BUTTON_WIDTH,
  gap: number = GAP
) => {
  const [isExpand, setIsExpand] = useState(false);
  const [order, setOrder] = useState<number>(DEFAULT_VALUE);

  const calElementOrder = () =>
    isExpand
      ? MAX_ORDER
      : calculateCollapsedButtonOrder(target?.current as HTMLDivElement, {
          limit,
          gap,
          buttonWidth
        });

  // 畫面縮放時，重新計算
  useEffect(() => {
    const handleResize = debounce(() => {
      setOrder(calElementOrder());
    }, 500);

    Event.dispatch('resize', handleResize);

    return () => {
      Event.remove('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    setOrder(calElementOrder());
  }, [target, isExpand]);

  return { isExpand, setIsExpand, order };
};

export default useFolder;
